import Title from 'app/ui/display/Title';
import ScoreDisplay from 'app/ui/display/ScoreDisplay';
import LevelScoreDisplay from 'app/ui/display/LevelScoreDisplay';
import Starburst from 'app/display/ui/Starburst';
import ButtonSimple from 'app/ui/buttons/ButtonSimple';
import BackgroundColourFill from 'app/display/backgrounds/BackgroundColourFill';
import * as AppConstants from 'app/constants/AppConstants';

export default class HudLevelFail extends Phaser.Group {
  constructor({ game, totalLevelScore, newGameScore, collectTarget }) {
    super(game);

    this.totalLevelScore = totalLevelScore;
    this.newGameScore = newGameScore;
    this.collectTarget = collectTarget;

    this.background = new BackgroundColourFill({ game, colour: '#000000', alpha: 0.5 });
    this.add(this.background);

    // container to house and position contents
    this.container = this.game.make.group();
    this.add(this.container);

    // baking panel
    this.panel = this.game.make.image(0, 0, 'ui', 'panel_generic');
    this.container.add(this.panel);

    // display Gnasher if player completed the level, display dennis if player did not
    this.character = this.game.make.image(0, 0, 'modal_characters', 'modal_char_levelfail');
    this.character.y = 0;
    this.character.x = this.panel.width * 0.5 - this.character.width * 0.5;
    this.container.addAt(this.character, 0);

    // add title, positiing would depend on what character is being displayed
    this.title = new Title({ game, title: Title.OHNO });
    this.title.x = this.panel.width * 0.5 - this.title.width * 0.5;
    this.title.y = this.character.height * 0.75;
    this.container.add(this.title);

    // adjust panel positon based on title position
    this.panel.y = this.title.y + this.title.height * 0.3;

    // score displays
    this.scoreDisplay = new ScoreDisplay({ game, score: 0, target: this.collectTarget, scoreColour: AppConstants.FONT_COLOUR_SCORE_FAIL });
    this.scoreDisplay.x = this.panel.width * 0.5 - this.scoreDisplay.width * 0.5;
    this.scoreDisplay.y = this.title.y + this.title.height + 50;
    this.container.addChild(this.scoreDisplay);

    // total score display
    this.totalScoreDisplay = new LevelScoreDisplay({
      game: this.game,
      score: this.newGameScore,
      labelCopy: this.game.copy.getCopy('total_score') + ' : ',
    });
    this.totalScoreDisplay.x = this.panel.width * 0.5 - this.totalScoreDisplay.width * 0.5;
    this.totalScoreDisplay.y = this.scoreDisplay.y + this.scoreDisplay.height + 20;

    // try again button
    this.btnTryAgain = new ButtonSimple({ game: this.game, id: 'btn_tryagain', skin: 'btn_tryagain' });
    this.btnTryAgain.x = this.panel.width * 0.5;
    this.btnTryAgain.y = this.totalScoreDisplay.y + this.totalScoreDisplay.height + this.btnTryAgain.height * 0.75;
    this.btnTryAgain.onInputDown.add(this.handleTryAgain, this);

    // adjust panel height to match content
    this.panel.height = this.btnTryAgain.y - this.panel.y;

    // positioning
    this.game.scale.onSizeChange.add(this.handleScreenResize, this);
    this.fixedToCamera = true;
    this.handleScreenResize();

    this.scoreDisplay.onAnimatedScoreUpdated.add(this.handleAnimatedScoreUpdate, this);
    this.scoreDisplay.onAnimatedScoreComplete.add(this.handleAnimatedScoreComplete, this);
    this.scoreDisplay.animateScore(0, this.totalLevelScore);
  }

  handleScreenResize() {
    this.container.x = this.game.width * 0.5 - this.width * 0.5;
    this.container.y = this.game.height * 0.5 - this.height * 0.5;
  }

  handleAnimatedScoreUpdate() {
    this.scoreDisplay.x = this.panel.width * 0.5 - this.scoreDisplay.width * 0.5;
  }

  handleAnimatedScoreComplete() {
    this.handleAnimatedScoreUpdate();
    this.container.add(this.totalScoreDisplay);
    this.addStarBurst(this.panel.width / 2, this.totalScoreDisplay.y);
    this.container.add(this.btnTryAgain);
  }

  addStarBurst(x, y) {
    const starBurst = new Starburst({ game: this.game });
    starBurst.scale.set(2);
    starBurst.position.set(x, y);
    this.container.add(starBurst);
  }

  /*
  ============================================================================================
    GETTERS
  ============================================================================================
  */

  get height() {
    return this.panel.height + this.panel.y;
  }

  get width() {
    return this.panel.width;
  }

  /*
  ============================================================================================
    EVENT HANDLERS
  ============================================================================================
  */

  handleTryAgain() {
    this.game.controller.replayLevel();
    this.destroy();
  }

  /*
  ============================================================================================
    TOODLES!
  ============================================================================================
  */

  destroy() {
    this.game.scale.onSizeChange.remove(this.handleScreenResize, this);
    this.btnTryAgain.onInputDown.remove(this.handleTryAgain, this);
    this.btnTryAgain.destroy(true);

    this.scoreDisplay.destroy(true);
    this.title.destroy(true);
    this.character.destroy(true);
    this.panel.destroy(true);
    this.container.destroy(true);

    // nullify
    this.btnTryAgain = null;
    this.btnNextLevel = null;
    this.btnReplay = null;
    this.highScoreDisplay = null;
    this.scoreDisplay = null;
    this.title = null;
    this.character = null;
    this.panel = null;
    this.container = null;

    // super dupa
    super.destroy(true);
  }
}
